// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"293":"component---src-pages-index-js","563":"cb355538"}[chunkId] + "-" + {"293":"5effce7f6fe077974e98","563":"9770908245d54596c24f"}[chunkId] + ".js";
};